(() => {
  'use strict';
  if (customElements.get('am-purchase-options')) return;
  class PurchaseOptions extends HTMLElement {
    connectedCallback() {
      const host = document.getElementById('MainProduct-' + this.dataset.section);
      if (!host || this.ready) return;
      this.ready = true;
      this.host = host;
      this.sync = () => {
        const form = document.getElementById('product-form-' + this.dataset.section);
        const plan = form && new FormData(form).get('selling_plan');
        this.querySelectorAll('[data-am-plan]').forEach(card => card.classList.toggle('is-selected', String(plan || '') === card.dataset.amPlan));
        this.dispatchEvent(new CustomEvent('am:purchase-updated', { bubbles: true }));
      };
      host.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.host?.removeEventListener('change', this.sync);
      this.ready = false;
    }
  }
  customElements.define('am-purchase-options', PurchaseOptions);
})();
